import React from 'react';
import { Outlet } from 'react-router-dom';

export default function EmptyLayout() {

    return (
        <main>
            <div className='bg-verylight min-h-svh'>
                <Outlet />
            </div>
        </main>
    )
}
